import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { width: "40rem" },
      on: { "click:outside": _vm.closeDialog },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        VCard,
        [
          _c(
            VCardTitle,
            {
              staticClass: "headline lighten-2",
              attrs: { "primary-title": "" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("gridView.selectCompetitors.modalTitle")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            VForm,
            {
              attrs: { "lazy-validation": "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [
              _c(
                VCardText,
                [
                  _c(VAutocomplete, {
                    attrs: {
                      multiple: "",
                      dense: "",
                      solo: "",
                      flat: "",
                      "small-chips": "",
                      "hide-details": "",
                      items: _vm.competitorOptions,
                      label: _vm.$t("pricing.mainHeaders.competitors"),
                    },
                    model: {
                      value: _vm.selectedCompetitorKeys,
                      callback: function ($$v) {
                        _vm.selectedCompetitorKeys = $$v
                      },
                      expression: "selectedCompetitorKeys",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "cancel-btn",
                      attrs: { small: "", text: "", outlined: "" },
                      on: { click: _vm.closeDialog },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("actions.cancel")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "save",
                      attrs: { small: "", color: "primary" },
                      on: { click: _vm.download },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("actions.download")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }